export const SET = 'SET'
export const EMPTY = 'EMPTY'
export const LOAD = 'LOAD'
export const LOADING = 'LOADING'
export const PUT = 'PUT'
export const ARCHIVED = 'ARCHIVED'
export const RESET = 'RESET'

export default {
  SET,
  EMPTY,
  LOAD,
  LOADING,
  PUT,
  ARCHIVED,
  RESET,
}

export const noPersist = [LOADING]
